import React, { useState, useEffect, useContext, useMemo } from "react";
import { createContext } from "react";

export const OwnerContext = createContext(null);

export const OwnerProvider = ({ children }) => {
  // Initialize from localStorage if available
  const [owner, setOwner] = useState(() => {
    const savedOwner = localStorage.getItem("currentOwner");
    return savedOwner || "";
  });

  // Save to localStorage whenever owner changes
  useEffect(() => {
    localStorage.setItem("currentOwner", owner);
  }, [owner]);

  // Memoize so consumers get a stable reference (setOwner is already stable).
  const value = useMemo(() => ({ owner, setOwner }), [owner]);

  return (
    <OwnerContext.Provider value={value}>
      {children}
    </OwnerContext.Provider>
  );
};

// Custom hook for easier context usage
export const useOwner = () => {
  const context = useContext(OwnerContext);
  if (context === undefined) {
    throw new Error("useOwner must be used within an OwnerProvider");
  }
  return context;
};
